import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '../../../CrudForm/enums/FormMode'
import { SubmitType } from '../../../CrudForm/enums/SubmitType'
import { useCrudFormStore } from '../../../CrudForm/Store/hooks/useStore'
import { useCrudModalFormStore } from '../../Store/hooks/useStore'

import { SaveButtonProps } from './interface'

export const SaveButton = ({
  icon,
  type = 'primary',
  children = '保存',
  ...restProps
}: SaveButtonProps) => {
  const { toggleModalOpen } = useCrudModalFormStore(state =>
    pick(state, ['toggleModalOpen'])
  )
  const { mode, submitLoading, submit } = useCrudFormStore(state =>
    pick(state, ['mode', 'submitLoading', 'submit'])
  )

  const handleSave = async () => {
    await submit({ submitType: SubmitType.SAVE })
    toggleModalOpen()
  }

  return mode === FormMode.READ ? null : (
    <ActionButton
      ghost
      htmlType='submit'
      icon={icon}
      loading={submitLoading}
      type={type}
      onClick={handleSave}
      {...restProps}
    >
      {children}
    </ActionButton>
  )
}
